export default {
    label_task:{
        en:"Seasons",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Season",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Season",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Season",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_expected_delivery_at:{
        en:"Expected Delivery Date",
        bn:"প্রিফিক্স"
    },
    label_expected_sowing_at :{
        en:"Expected Sowing date",
        bn:"কর্মচারী আইডি"
    },
    label_expected_reporting_at:{
        en:"Expected Reporting date",
        bn:"পাসওয়ার্ড"
    },
}